/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import { Box } from "@mui/material";
import ContentLoader from "react-content-loader";

export const MyCasesLoader = () => (
  <>
    <Box sx={{ display: { xs: "none", md: "block" } }}>
      <ContentLoader speed={2} width={500} height={120} viewBox="0 0 500 120" backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
        <rect x="18" y="11" rx="3" ry="3" width="407" height="3" />
        <circle cx="64" cy="63" r="29" />
        <rect x="120" y="35" rx="0" ry="0" width="124" height="23" />
        <rect x="119" y="69" rx="0" ry="0" width="273" height="20" />
        <rect x="277" y="19" rx="0" ry="0" width="145" height="12" />
      </ContentLoader>
    </Box>
    <Box sx={{ display: { xs: "block", sm: "none" } }}>
      <ContentLoader speed={2} width={310} height={120} viewBox="0 0 310 120" backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
        <circle cx="52" cy="58" r="21" />
        <rect x="90" y="37" rx="2" ry="2" width="104" height="15" />
        <rect x="90" y="64" rx="2" ry="2" width="202" height="15" />
        <rect x="162" y="16" rx="0" ry="0" width="129" height="7" />
        <rect x="12" y="6" rx="0" ry="0" width="293" height="3" />
      </ContentLoader>
    </Box>
  </>
);
